<template>
  <div class="cards" @click="$emit('someEvent')">
    <div class="card">
      <span>{{ title}}</span>
      <h2 class="titleCard">{{ subtitle }}</h2>
      <h3 class="subTitleCard">{{ qtd }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: ["title", "qtd", "cards", 'subtitle'],
};
</script>

<style scoped>
.cards {
  width: 300px;
  height: 100%;
  justify-content: center;
  padding: 1rem;
  background-color: var(--white);
  border-radius: 5px;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  cursor: pointer;
  font-size: max(.9rem,1.3vw);
  grid-gap: 0.4rem;
  gap: 0.4rem;
  border: 1px solid var(--gray_text);

}

.cards .card {
  width: 100%;
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
}

.cards .card .titleCard {
  font-size: 1.5rem;
}

.cards .card .subTitleCard {
  font-size: 1.3rem;
  /* color: var(--green); */
}

@media (max-width: 425px) {
  .cards {
    width: 47%;
  }
  .cards .card .titleCard {
    font-size: 1.2rem;
  }
  .cards .card .subTitleCard {
    font-size: 1rem;
  }
}

@media (max-width: 320px) {
  .cards {
    width: 100%;
  }
}
</style>
